<template>
    <v-form ref="caseCreationOrderForm" v-model="formValid">
        <v-layout row>
            <v-flex xs9 md5 lg4>
                <v-text-field
                        :disabled="readOnly"
                        v-model="patientName"
                        :counter="100"
                        :label="$t('caseCreationOrderForm.fields.patientName.label')"
                        class="required-field"
                        required
                        :rules="patientNameRules"
                        :errorMessages="errorMessages['patientName']"
                ></v-text-field>
            </v-flex>
            <v-flex xs3 md2 lg1>
                <v-select
                        :disabled="readOnly"
                        :items="genderOptions"
                        v-model="patientGender"
                        :label="$t('caseCreationOrderForm.fields.patientGender.label')"
                        item-value="value"
                        item-text="title"
                        class="required-field"
                        required
                        :rules="patientGenderRules"
                        :errorMessages="errorMessages['patientGender']"
                ></v-select>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs6 md3 lg2>
                <v-menu
                        :disabled="readOnly"
                        ref="birthdayPickerMenu"
                        :close-on-content-click="false"
                        v-model="birthdayPickerMenu"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                >
                    <v-text-field
                            :disabled="readOnly"
                            slot="activator"
                            :value="patientBirthdayInput"
                            :label="$t('caseCreationOrderForm.fields.patientBirthday.label')"
                            :placeholder="$t('caseCreationOrderForm.fields.patientBirthday.placeholder')"
                            prepend-icon="event"
                            maxlength="10"
                            class="required-field"
                            required
                            :rules="patientBirthdayRules"
                            :errorMessages="errorMessages['patientBirthday']"
                            @input="handlePatientBirthdayInput"
                            @blur="normalizePatientBirthdayInput"
                    ></v-text-field>
                    <v-date-picker
                            ref="birthdayPicker"
                            v-model="patientBirthday"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1900-01-01"
                            :locale="$i18n.locale"
                            @change="savePatientBirthday"
                    ></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs6 md4 lg3>
                <v-select
                        :disabled="readOnly"
                        :items="placeOptions"
                        v-model="patientRegistrationPlace"
                        :label="$t('caseCreationOrderForm.fields.patientRegistrationPlace.label')"
                        item-value="value"
                        item-text="title"
                        required
                        :errorMessages="errorMessages['patientRegistrationPlace']"
                ></v-select>
              </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 md7 lg5>
                <v-text-field
                        :disabled="readOnly"
                        v-model="patientAddress"
                        prepend-icon="place"
                        :counter="100"
                        :label="$t('caseCreationOrderForm.fields.patientAddress.label')"
                        :rules="patientAddressRules"
                        :errorMessages="errorMessages['patientAddress']"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs6 md3 lg2>
                <v-text-field
                        :disabled="readOnly"
                        v-model="patientPhone"
                        placeholder="+7-xxx-xxx-xx-xx"
                        :counter="25"
                        :label="$t('caseCreationOrderForm.fields.patientPhone.label')"
                        :rules="patientPhoneRules"
                        :errorMessages="errorMessages['patientPhone']"
                ></v-text-field>
            </v-flex>
            <v-flex xs6 md4 lg3>
                <v-text-field
                        :disabled="readOnly"
                        v-model="patientEmail"
                        :counter="50"
                        :label="$t('caseCreationOrderForm.fields.patientEmail.label')"
                        :rules="patientEmailRules"
                        :errorMessages="errorMessages['patientEmail']"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs6 md3 lg2>
                <v-text-field
                        :disabled="readOnly"
                        v-model="patientSnils"
                        :counter="11"
                        maxlength="11"
                        :label="$t('caseCreationOrderForm.fields.patientSnils.label')"
                        :rules="patientSnilsRules"
                        :errorMessages="errorMessages['patientSnils']"
                ></v-text-field>
            </v-flex>
            <v-flex xs6 md4 lg3>
                <v-text-field
                        :disabled="readOnly"
                        v-model="patientOmi"
                        :counter="16"
                        maxlength="16"
                        :label="$t('caseCreationOrderForm.fields.patientMedicalInsurance.label')"
                        :rules="patientMedicalInsuranceRules"
                        :errorMessages="errorMessages['patientOmi']"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 md7 lg5>
                <v-text-field
                        :disabled="readOnly"
                        v-model="externalId"
                        :counter="1000"
                        :label="$t('caseCreationOrderForm.fields.externalId.label')"
                        :rules="externalIdRules"
                        :errorMessages="errorMessages['externalId']"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 md7 lg5>
                <v-text-field
                        :disabled="readOnly"
                        v-model="externalLabel"
                        :counter="1000"
                        :label="$t('caseCreationOrderForm.fields.externalLabel.label')"
                        :rules="externalLabelRules"
                        :errorMessages="errorMessages['externalLabel']"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 md2 lg1>
                <v-text-field
                        :disabled="readOnly"
                        v-model="icd10"
                        :counter="200"
                        :label="$t('caseCreationOrderForm.fields.icd10.label')"
                        :errorMessages="errorMessages['icd10']"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md5 lg4>
                <v-text-field
                        :disabled="readOnly"
                        v-model="diagnosis"
                        :counter="200"
                        :label="$t('caseCreationOrderForm.fields.diagnosis.label')"
                        class="required-field"
                        :rules="diagnosisRules"
                        required
                        :errorMessages="errorMessages['diagnosis']"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md7 lg5>
            <v-text-field :label="$t('caseCreationOrderForm.fields.material_sampling.label')" v-model="material_sampling" type="datetime-local"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 md7 lg5>
                <div class="receive-material-method">
                    <div class="receive-material-method__label">{{ $t('caseCreationOrderForm.fields.receiveMaterialMethod.label') }}</div>
                    <v-checkbox
                            v-for="option in receiveMaterialMethodOptions"
                            :key="option.value"
                            :disabled="readOnly"
                            v-model="receiveMaterialMethod"
                            :label="option.title"
                            :value="option.value"
                            hide-details
                            class="mt-0"
                    ></v-checkbox>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 md7 lg5>
                <v-autocomplete
                        :disabled="readOnly"
                        :items="clientSpecialists"
                        v-model="clientSpecialist"
                        item-text="name"
                        item-value="id"
                        :no-data-text="$t('common.autocomplete.noDataText')"
                        :label="$t('caseCreationOrderForm.fields.clientSpecialist.label')"
                        :errorMessages="errorMessages['clientSpecialist']"
                ></v-autocomplete>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md7 lg5>
                <v-textarea
                        :disabled="readOnly"
                        v-model="clinicalData"
                        :label="$t('caseCreationOrderForm.fields.clinicalData.label')"
                        auto-grow
                        required
                        :rules="clinicalDataRules"
                        :errorMessages="errorMessages['clinicalData']"
                ></v-textarea>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md7 lg5>
                <v-text-field
                        :disabled="readOnly"
                        v-model="examination"
                        :label="$t('caseCreationOrderForm.fields.examination.label')"
                        :errorMessages="errorMessages['examination']"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row class="mt-2">
            <v-flex xs12 md4 lg4 wrap>
                <h3>{{ $t('caseCreationOrderForm.subtitle.files.label') }} <span class="required-mark">*</span></h3>
                <files :readOnly="readOnly" :files="caseCreationOrder.files" @updateFiles="handleUpdateFiles"></files>
                <div v-if="shouldShowRequiredErrors && missingRequiredSections.files" class="required-section-error">
                  {{ $t('caseCreationOrderForm.requiredSections.files') }}
                </div>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row class="mt-2">
            <v-flex xs12 md4 lg4 wrap>
                <h3>{{ $t('caseCreationOrderForm.subtitle.materials.label') }} <span class="required-mark">*</span></h3>
                <materials :readOnly="readOnly"
                           :materialsByType="caseCreationOrder.materials"
                           :creationFormState="materialsCreationFormState"
                           :checkMaterialExistsFunc="checkMaterialExists"
                           @createMaterial="handleCreateMaterial"
                           @deleteMaterial="handleDeleteMaterial"
                            ></materials>
                <div v-if="shouldShowRequiredErrors && missingRequiredSections.materials" class="required-section-error">
                  {{ $t('caseCreationOrderForm.requiredSections.materials') }}
                </div>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row class="mt-2">
            <v-flex xs12 md8 lg7 wrap>
                <h3>{{ $t('caseCreationOrderForm.subtitle.services.label') }} <span class="required-mark">*</span></h3>
                <services :readOnly="readOnly"
                          :availableServicesById="availableServicesById"
                          :availableServices="availableServicesForClient"
                          :selectedServices="caseCreationOrder.services"
                          @addService="handleAddService"
                          @removeService="handleRemoveService"
                          @changeQuantity="handleChangeQuantity"
                ></services>
                <div v-if="shouldShowRequiredErrors && missingRequiredSections.services" class="required-section-error">
                  {{ $t('caseCreationOrderForm.requiredSections.services') }}
                </div>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 md8 lg7 wrap>
                <v-alert
                        :value="!!errorMessages['common']"
                        color="error"
                        outline
                >
                    {{ errorMessages['common'] }}
                </v-alert>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>

  import Services from './Services'
  import Materials from './Materials'
  import Files from './Files'
  import _ from 'lodash'
  import {validateStringLength} from '../../helpers/validation'

  export default {
    name: 'case-creation-order-form',
    props: {
      context: {
        Type: String
      },
      caseCreationOrder: {
        Type: Object
      },
      currentClient: {
        Type: Object
      },
      servicesByClients: {
      },
      availableServicesById: {
      },
      valid: {

      },
      errorMessages: {
        Type: Object,
      },
      readOnly: {
        Type: Boolean
      },
      materialsCreationFormState: {
        Type: Object
      },
      checkMaterialExistsFunc: {
        Type: Function
      },
      missingRequiredSections: {
        type: Object,
        default: () => ({})
      },
      showRequiredSectionErrors: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Services,
      Materials,
      Files
    },
    data () {
      return {
        birthdayPickerMenu: false,
        patientBirthdayInput: '',
        genderOptions: [
          {
            title: this.$t('caseCreationOrderForm.fields.patientGender.options.male'),
            value: 'm'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.patientGender.options.female'),
            value: 'f'
          }
        ],
        placeOptions: [
          {
            title: this.$t('caseCreationOrderForm.fields.patientPlace.options.CITY'),
            value: 'CITY'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.patientPlace.options.COUNTRY'),
            value: 'COUNTRY'
          },
        ],
        receiveMaterialMethodOptions: [
          {
            title: this.$t('caseCreationOrderForm.fields.receiveMaterialMethod.options.endoscopic'),
            value: 'endoscopic'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.receiveMaterialMethod.options.needle'),
            value: 'needle'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.receiveMaterialMethod.options.aspiration'),
            value: 'aspiration'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.receiveMaterialMethod.options.incisional'),
            value: 'incisional'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.receiveMaterialMethod.options.excisional'),
            value: 'excisional'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.receiveMaterialMethod.options.surgical'),
            value: 'surgical'
          },
          {
            title: this.$t('caseCreationOrderForm.fields.receiveMaterialMethod.options.shed'),
            value: 'shed'
          }
        ],
        patientNameRules: [
          v => !!v || this.$t('caseCreationOrderForm.fields.patientName.errors.required'),
          v => (v && v.length <= 50) || this.$t('caseCreationOrderForm.fields.patientName.errors.length')
        ],
        patientGenderRules: [
          v => !!v || this.$t('caseCreationOrderForm.fields.patientGender.errors.required'),
        ],
        patientBirthdayRules: [
          v => !!v || this.$t('caseCreationOrderForm.fields.patientBirthday.errors.required'),
          () => this.isPatientBirthdayInputValid() || this.$t('caseCreationOrderForm.fields.patientBirthday.errors.invalid'),
        ],
        patientAddressRules: [
          _.partial(validateStringLength, _, 100, this.$t('caseCreationOrderForm.fields.patientAddress.errors.length'))
        ],
        patientPhoneRules: [
          _.partial(validateStringLength, _, 25, this.$t('caseCreationOrderForm.fields.patientPhone.errors.length'))
        ],
        patientEmailRules: [
          _.partial(validateStringLength, _, 50, this.$t('caseCreationOrderForm.fields.patientEmail.errors.length'))
        ],
        patientMedicalInsuranceRules: [
          v => {
            if (!v) {
              return true
            }
            return /^\d{16}$/.test(v) || this.$t('caseCreationOrderForm.fields.patientMedicalInsurance.errors.format')
          }
        ],
        patientSnilsRules: [
          _.partial(validateStringLength, _, 11, this.$t('caseCreationOrderForm.fields.snils.errors.length')),
          (e) => {return this.snilsValidate(e) || this.$t('caseCreationOrderForm.fields.snils.errors.valid')}
        ],
        externalIdRules: [
          _.partial(validateStringLength, _, 1000, this.$t('caseCreationOrderForm.fields.externalId.errors.length'))
        ],
        externalLabelRules: [
          _.partial(validateStringLength, _, 1000, this.$t('caseCreationOrderForm.fields.externalLabel.errors.length'))
        ],
        diagnosisRules: [
          v => !!v || this.$t('caseCreationOrderForm.fields.diagnosis.errors.required'),
          v => (v && v.length <= 200) || this.$t('caseCreationOrderForm.fields.diagnosis.errors.length')
        ],
        clinicalDataRules: [
          _.partial(validateStringLength, _, 10000, this.$t('caseCreationOrderForm.fields.clinicalData.errors.length'))
        ]
      }
    },
    watch: {
      patientBirthday (value) {
        this.patientBirthdayInput = this.formatDateForInput(value)
      }
    },
    computed: {
      clientSpecialists () {
        return this.currentClient.specialists || []
      },
      shouldShowRequiredErrors () {
        return this.showRequiredSectionErrors && !this.readOnly
      },
      availableServicesForClient () {
        const currentClientId = _.get(this.currentClient, 'id', null)

        if (!currentClientId) {
          return []
        }

        const servicesByClient = this.servicesByClients[currentClientId] || {}

        let resultServices = []
        for (let serviceId in servicesByClient) {
          const service = this.availableServicesById[serviceId]

          if (!service) {
            continue
          }

          resultServices.push({
            ...service,
            externalId: servicesByClient[serviceId].externalId,
            price: servicesByClient[serviceId].price,
            currency: servicesByClient[serviceId].currency,
            hidden: servicesByClient[serviceId].hidden
          })
        }

        return resultServices
      },
      notSelectedServices () {
        const currentClientId = _.get(this.currentClient, 'id', null)

        if (!currentClientId) {
          return []
        }

        const selectedServicesById = _.keyBy(this.caseCreationOrder.services, 'id')
        const services = _.get(this.servicesByClients, currentClientId, [])

        let availableServices = []
        for (let serviceId in services) {
          let alreadyAppendedService = selectedServicesById[serviceId]

          if (alreadyAppendedService) {
            continue
          }

          let availableService = _.cloneDeep(this.availableServicesById[serviceId])

          if (!availableService) {
            continue
          }

          availableService.fullTitle = `(${availableService.code}) ${availableService.title}`
          availableServices.push(availableService)
        }

        return availableServices
      },
      formValid: {
        get () {
          return this.valid
        },
        set (value) {
          this.$emit('changeFormValid', {context: this.context, value: value})
        }
      },
      patientName: {
        get () {
          return this.caseCreationOrder.patientName
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'patientName', value: value})
        }
      },
      patientGender: {
        get () {
          return this.caseCreationOrder.patientGender
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'patientGender', value: value})
        }
      },
      patientBirthday: {
        get () {
          return this.caseCreationOrder.patientBirthday
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'patientBirthday', value: value})
        }
      },
      patientAddress: {
        get () {
          return this.caseCreationOrder.patientAddress
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'patientAddress', value: value})
        }
      },
      patientPhone: {
        get () {
          return this.caseCreationOrder.patientPhone
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'patientPhone', value: value})
        }
      },
      patientEmail: {
        get () {
          return this.caseCreationOrder.patientEmail
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'patientEmail', value: value})
        }
      },
      patientSnils: {
        get () {
          return this.caseCreationOrder.snils
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'snils', value: value})
        }
      },
      patientRegistrationPlace: {
        get () {
          return this.caseCreationOrder.registration_place
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'registration_place', value: value})
        }
      },
      patientOmi: {
        get () {
          return this.caseCreationOrder.omi_policy_number
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'omi_policy_number', value: value})
        }
      },
      icd10: {
        get () {
          return this.caseCreationOrder.icd10
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'icd10', value: value})
        }
      },
      material_sampling: {
        get () {
          if (this.caseCreationOrder.material_sampling) {
            const date = new Date(this.caseCreationOrder.material_sampling);
            return date.toISOString().replace("Z", "")
          }
        },
        set (value) {
          const date = new Date(value);
          const userTimezoneOffset = date.getTimezoneOffset() * 60000;
          const d = new Date(date.getTime() - userTimezoneOffset);
          this.$emit('updateFormField', {context: this.context, fieldName: 'material_sampling', value: d.toISOString()})
        }
      },
      clinicalData: {
        get () {
          return this.caseCreationOrder.clinicalData
        },
        set: _.debounce(function (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'clinicalData', value: value})
        }, 500)
      },
      externalId: {
        get () {
          return this.caseCreationOrder.externalId
        },
        set: _.debounce(function (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'externalId', value: value})
        }, 500)
      },
      externalLabel: {
        get () {
          return this.caseCreationOrder.externalLabel
        },
        set: _.debounce(function (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'externalLabel', value: value})
        }, 500)
      },
      diagnosis: {
        get () {
          return this.caseCreationOrder.diagnosis
        },
        set: _.debounce(function (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'diagnosis', value: value})
        }, 500)
      },
      clientSpecialist: {
        get () {
          return this.caseCreationOrder.clientSpecialist
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'clientSpecialist', value: value})
        }
      },
      receiveMaterialMethod: {
        get () {
          return this.caseCreationOrder.receiveMaterialMethod || []
        },
        set (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'receiveMaterialMethod', value: value})
        }
      },
      examination: {
        get () {
          return this.caseCreationOrder.examination
        },
        set: _.debounce(function (value) {
          this.$emit('updateFormField', {context: this.context, fieldName: 'examination', value: value})
        }, 500)
      }
    },
    methods: {
      formatDateForInput (value) {
        if (!value) {
          return ''
        }
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
        if (!match) {
          return ''
        }
        return `${match[3]}.${match[2]}.${match[1]}`
      },
      normalizeDateInput (value) {
        const digits = (value || '').replace(/\D/g, '').slice(0, 8)
        if (digits.length <= 2) {
          return digits
        }
        if (digits.length <= 4) {
          return `${digits.slice(0, 2)}.${digits.slice(2)}`
        }
        return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`
      },
      parseBirthdayInput (value) {
        if (!value) {
          return null
        }

        const match = value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
        if (!match) {
          return null
        }

        const day = Number(match[1])
        const month = Number(match[2])
        const year = Number(match[3])
        const parsedDate = new Date(Date.UTC(year, month - 1, day))

        if (
          parsedDate.getUTCFullYear() !== year ||
          parsedDate.getUTCMonth() !== month - 1 ||
          parsedDate.getUTCDate() !== day
        ) {
          return null
        }

        const isoDate = `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
        const todayIsoDate = new Date().toISOString().substr(0, 10)
        if (isoDate < '1900-01-01' || isoDate > todayIsoDate) {
          return null
        }

        return isoDate
      },
      isPatientBirthdayInputValid () {
        if (!this.patientBirthdayInput) {
          return true
        }
        return !!this.parseBirthdayInput(this.patientBirthdayInput)
      },
      handlePatientBirthdayInput (value) {
        const normalizedValue = this.normalizeDateInput(value)
        this.patientBirthdayInput = normalizedValue

        const parsedValue = this.parseBirthdayInput(normalizedValue)
        if (parsedValue) {
          this.patientBirthday = parsedValue
          return
        }

        if (!normalizedValue) {
          this.patientBirthday = null
        }
      },
      normalizePatientBirthdayInput () {
        const parsedValue = this.parseBirthdayInput(this.patientBirthdayInput)
        if (parsedValue) {
          this.patientBirthdayInput = this.formatDateForInput(parsedValue)
        }
      },
      snilsValidate(snils) {
        if (!snils) {
          return true
        }
        var result = false;
        let error = {}
        if (typeof snils === 'number') {
          snils = snils.toString();
        } else if (typeof snils !== 'string') {
          snils = '';
        }
        if (!snils.length) {
          error.code = 1;
          error.message = 'СНИЛС пуст';
        } else if (/[^0-9]/.test(snils)) {
          error.code = 2;
          error.message = 'СНИЛС может состоять только из цифр';
        } else if (snils.length !== 11) {
          error.code = 3;
          error.message = 'СНИЛС может состоять только из 11 цифр';
        } else {
          var sum = 0;
          for (var i = 0; i < 9; i++) {
            sum += parseInt(snils[i]) * (9 - i);
          }
          var checkDigit = 0;
          if (sum < 100) {
            checkDigit = sum;
          } else if (sum > 101) {
            checkDigit = parseInt(sum % 101);
            if (checkDigit === 100) {
              checkDigit = 0;
            }
          }
          if (checkDigit === parseInt(snils.slice(-2))) {
            result = true;
          } else {
            error.code = 4;
            error.message = 'Неправильное контрольное число';
        }
        }
        return result;
      },
      handleUpdateFiles(files) {
        this.$emit('updateFiles', {
          files: files,
          context: this.context
        })
      },
      handleCreateMaterial(material) {
        this.$emit('createMaterial', {
          material: material,
          context: this.context
        })
      },
      handleDeleteMaterial(event) {
        this.$emit('deleteMaterial', {
          context: this.context,
          ...event
        })
      },
      handleAddService(serviceId) {
        this.$emit('addService', {
          context: this.context,
          serviceId: serviceId
        })
      },
      handleRemoveService(serviceId) {
        this.$emit('removeService', {
          context: this.context,
          serviceId: serviceId
        })
      },
      handleChangeQuantity(event) {
        this.$emit('changeServiceQuantity', {
          context: this.context,
          ...event
        })
      },
      savePatientBirthday (date) {
        this.patientBirthdayInput = this.formatDateForInput(date)
        this.$refs.birthdayPickerMenu.save(date)
      },
      initPatientBirthdayInput () {
        this.patientBirthdayInput = this.formatDateForInput(this.patientBirthday)
      },
      reset () {
        this.$refs['caseCreationOrderForm'].reset()
        this.patientBirthdayInput = ''
      },
      validate () {
        return this.$refs['caseCreationOrderForm'].validate()
      },
      checkMaterialExists(code) {
        return this.checkMaterialExistsFunc(code)
      },
    },
    mounted () {
      this.initPatientBirthdayInput()
    }
  }
</script>

<style scoped>
.required-mark {
  color: #ff5252;
}
.required-section-error {
  color: #ff5252;
  margin-top: 8px;
}
.receive-material-method__label {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
  margin-bottom: 4px;
}
</style>